import { addConcession } from '@/app/order/checkout/action'
import Button from '@a24/ui/Button'
import SanityImage from '@a24/ui/SanityImage'
import type { ISanityImageProps } from '@a24/ui/SanityImage'
import Title from '@a24/ui/Title'
import { useState, useTransition } from 'react'
import { useErrorToast } from '../toastHook'

export interface IConcessionCardProps {
  id: string
  title: string
  image?: ISanityImageProps['sanityImageSourceData']
  price: string
}
const ConcessionCard = ({ id, image, price, title }: IConcessionCardProps) => {
  const [actionState, setActionState] =
    useState<Awaited<ReturnType<typeof addConcession>>>()
  const [isPending, startTransition] = useTransition()
  const handleAddToCart = () => {
    startTransition(async () => {
      // Add to cart logic here
      const res = await addConcession({ concessionId: id })
      startTransition(() => setActionState(res))
    })
  }
  useErrorToast(actionState)
  return (
    <article className='flex p-2 rounded border border-heritage-off-white-80 bg-heritage-white-full'>
      <div className='order-1 w-full flex justify-between flex-col'>
        <div className=''>
          {title && (
            <Title className='heading-xs pl-2' level='h3' text={title} />
          )}
          {price && (
            <span className='body-2xs mt-2 pl-2 text-heritage-off-white-40'>
              ${price}
            </span>
          )}
        </div>
        <div className='flex justify-end'>
          <Button
            onClick={handleAddToCart}
            disabled={isPending}
            aria-disabled={isPending}
            type='button'
            className='w-fit min-w-[120px] sm:min-w-[126px] button-secondary'
          >
            Add
          </Button>
        </div>
      </div>
      <SanityImage
        className='order-0 relative overflow-hidden bg-heritage-off-white-90 xl:max-w-[140px]'
        imageClassName='aspect-3/2 object-contain rounded w-full group-hover:scale-[105%] transition-card-image'
        sanityImageSourceData={
          image ||
          'https://cdn.sanity.io/images/sovogxyh/production/1d467bc1921cc305cf710c214102c694f70a0cd2-600x400.png'
        }
        height={384}
        width={480}
      />
    </article>
  )
}

export default ConcessionCard
